// Simple Google Maps loader compatible with Node.js 16
const loadGoogleMaps = (apiKey) => {
  return new Promise((resolve, reject) => {
    // Check if Google Maps is already loaded
    if (window.google && window.google.maps) {
      resolve(window.google)
      return
    }

    // Create script element
    const script = document.createElement('script')
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=initGoogleMaps`
    script.async = true
    script.defer = true

    // Define global callback
    window.initGoogleMaps = () => {
      resolve(window.google)
    }

    // Handle script load errors
    script.onerror = () => {
      reject(new Error('Failed to load Google Maps'))
    }

    // Add script to document
    document.head.appendChild(script)
  })
}

const loader = {
  load: () => loadGoogleMaps('AIzaSyB24tCL14XhXd19PcnlF7Or2m4jhjm_Fa0')
}

export default loader
